var watchlistDelete = {
	title: "Delete watchlist",
	nameInputLabel: "Watchlist Name",
	alertHeading: "Are you sure you want to delete the watchlist?",
	alertBody: "If yes, then click on ok. Please note that deleted watchlists cannot be restored.",
	confirmBtn: "Ok",
	cancelBtn: "Cancel"
};
var en = {
	watchlistDelete: watchlistDelete
};

export { en as default, watchlistDelete };
